var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:[
    _vm.styles.input,
    { 'border-red-500 hover:border-red-500 focus:border-red-600 text-red-600': _vm.hasErrors }
    ],domProps:{"value":_vm.value},on:_vm._d({"keyup":function($event){$event.stopPropagation();_vm.$root.productType !== undefined ? _vm.$root.stopArrows($event): ''}},[_vm.eventName,function($event){return _vm.$emit('input', $event.target.value)}])})
}
var staticRenderFns = []

export { render, staticRenderFns }